import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/Button';

const languages = {
  en: 'English',
  lt: 'Lietuvių'
};

export function LanguageSwitcher() {
  const { t, i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'lt' : 'en';
    i18n.changeLanguage(newLang);
  };

  const currentLang = i18n.language as keyof typeof languages;
  const nextLang = currentLang === 'en' ? 'lt' : 'en';

  return (
    <Button 
      variant="ghost" 
      size="sm"
      onClick={toggleLanguage}
      className="relative group"
      title={t('settings.language')}
    >
      <span className="flex items-center gap-1">
        {languages[currentLang]}
        <span className="text-xs text-gray-400 group-hover:text-gray-600">
          ▼
        </span>
      </span>
      <span className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 text-xs text-gray-500 opacity-0 group-hover:opacity-100 whitespace-nowrap transition-opacity">
        {t('settings.switchTo', { language: languages[nextLang] })}
      </span>
    </Button>
  );
}

export default LanguageSwitcher;
